import dayjs from 'dayjs'
import { nanoid } from 'nanoid'
import { http } from './http'
import { cloneDeep, isPlainObject } from 'lodash-es'
import { emitter } from './emitter'
import * as THREE from 'three'

/**
 * 格式化浮点数
 */
export const fomatFloat = (num: number, n: number) => {
  let f = parseFloat(`${num}`)
  if (isNaN(f)) {
    return 0
  }
  f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n) // n 幂
  return f
  // let s = f.toString()
  // let rs = s.indexOf('.')
  // // 判定如果是整数，增加小数点再补0
  // if (rs < 0) {
  //   rs = s.length
  //   s += '.'
  // }
  // while (s.length <= rs + n) {
  //   s += '0'
  // }
  // return s
}

/**
 * 格式化时间
 */
export function dealTime(time?: string) {
  return time?.split('.')[0]
}

export function formatTime(time: string, type: string) {
  return dayjs(time).format(type)
}
// 生成随机数坐标
function getRandomNumber(min: number, max: number) {
  return Math.floor(Math.random() * (max - min) + min)
}
// 生成随机坐标的不重叠圆
export function drawCircles(maxLength: number, radius: number, max_x: number, max_y: number) {
  const circles = []
  let anti_crash_count = 0
  while (circles.length < maxLength) {
    const circle = {
      x: getRandomNumber(radius, max_x - radius),
      y: getRandomNumber(radius, max_y - radius),
      radius
    }

    let isOverlapping = false

    for (let j = 0; j < circles.length; j++) {
      const previous_circle = circles[j]
      const distance = Math.hypot(circle.x - previous_circle.x, circle.y - previous_circle.y)

      if (distance < circle.radius + previous_circle.radius) {
        isOverlapping = true
        break
      }
    }

    if (!isOverlapping) {
      circles.push(circle)
    }
    anti_crash_count++
    if (anti_crash_count > 10000) {
      break
    }
  }
  return circles
}

// 获取地图json数据
export function getLOcalGeoJson(name: string) {
  return http.request({
    method: 'get',
    url: `/api/v1/map/data/${name}`
  })
}
function sum(x: number, y: number) {
  return x + y
}
function square(x: number) {
  return x * x
}

/**
 * 返回数组标准差
 * @param data 数据数组
 * @returns
 */
export function stddev(data: number[]) {
  const mean = data.reduce(sum) / data.length
  const deviations = data.map(function (x) {
    return x - mean
  })
  return Math.sqrt(deviations.map(square).reduce(sum) / (data.length - 1))
}

/**
 * 返回某个prop是否在obj中
 * @param obj
 * @param prop
 * @returns
 */
export function hasProp(obj: any, prop: string) {
  return obj && Object.prototype.hasOwnProperty.call(obj, prop)
}

/**
 * 分组
 * @param arr
 * @param key
 * @returns
 */
export function groupBy(arr: any[], key: string) {
  return arr.reduce((acc, cur) => {
    if (Object.prototype.hasOwnProperty.call(acc, cur[key])) {
      acc[cur[key]].push(cur)
    } else {
      acc[cur[key]] = [].concat(cur)
    }
    return acc
  }, {})
}

export function fillText(text: string, fontSize = 16, width = 100) {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')!
  const textWidth = ctx.measureText(text).width
  canvas.width = width > textWidth ? width : Math.round(textWidth * 1.6)
  canvas.height = fontSize
  // console.log(textWidth)

  ctx.font = `${fontSize}px Avenir, Helvetica, Arial, sans-serif`
  ctx.textAlign = 'center'

  // const scaleFactor = Math.min(1, width / textWidth)
  // ctx.translate(width / 2, height / 2)
  // ctx.scale(scaleFactor, 1)
  ctx.fillStyle = '#fff'
  ctx.fillText(text, Math.round(canvas.width / 2), Math.floor(fontSize * 0.85))
  return canvas
}
interface TextMeshResult {
  mesh: THREE.Mesh
  textWidth: number // 文字实际像素宽度
  textHeight: number // 文字实际像素高度
  canvasWidth: number // Canvas像素宽度
  canvasHeight: number // Canvas像素高度
  worldWidth: number // Three.js世界坐标宽度
  worldHeight: number // Three.js世界坐标高度
}
export function createTextMesh(
  text: string,
  fontSize = 16,
  canvasWidth = 30,
  scaleFactor = 1 / 50 // 缩放系数，你原来的 1/50
): TextMeshResult {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')!

  // 先测量文字
  ctx.font = `${fontSize}px Avenir, Helvetica, Arial, sans-serif`
  const textWidth = ctx.measureText(text).width

  // 设置Canvas尺寸
  const finalCanvasWidth = canvasWidth > textWidth ? canvasWidth : Math.round(textWidth * 1.2)
  const canvasHeight = fontSize
  canvas.width = finalCanvasWidth
  canvas.height = canvasHeight

  // 绘制文字
  ctx.font = `${fontSize}px Avenir, Helvetica, Arial, sans-serif`
  ctx.textAlign = 'center'
  ctx.fillStyle = '#fff'
  ctx.fillText(text, Math.round(finalCanvasWidth / 2), Math.floor(fontSize * 0.85))

  // 创建Three.js对象
  const worldWidth = finalCanvasWidth * scaleFactor
  const worldHeight = canvasHeight * scaleFactor

  const geometry = new THREE.PlaneGeometry(worldWidth, worldHeight)
  const material = new THREE.MeshBasicMaterial({
    map: new THREE.CanvasTexture(canvas),
    side: THREE.DoubleSide,
    transparent: true
  })

  const mesh = new THREE.Mesh(geometry, material)

  // 在mesh上存储尺寸信息以便后续使用
  mesh.userData.textInfo = {
    textWidth,
    textHeight: fontSize,
    canvasWidth: finalCanvasWidth,
    canvasHeight,
    worldWidth,
    worldHeight,
    scaleFactor
  }

  // 添加便捷方法
  ;(mesh as any).getTextWidth = () => textWidth
  ;(mesh as any).getWorldTextWidth = () => worldWidth

  return {
    mesh,
    textWidth,
    textHeight: fontSize,
    canvasWidth: finalCanvasWidth,
    canvasHeight,
    worldWidth,
    worldHeight
  }
}

// 使用示例
const textA = createTextMesh('文字A', 14, 100)
const textB = createTextMesh('文字B', 14, 100)

// 直接使用缓存的尺寸信息进行定位
const spacing = 0.1 // 间距
textA.mesh.position.set(0, 0, 0.02)
textB.mesh.position.set(textA.worldWidth / 2 + textB.worldWidth / 2 + spacing, 0, 0.02)

/**
 * 返回单个颜色或多个颜色的渐变色
 * @param oc
 * @returns
 */
export function composeColor(oc: string | any) {
  if (typeof oc === 'string' || !oc) {
    return oc
  }
  // console.log(JSON.stringify(oc))
  const { type, angle, list } = oc
  if (list?.length === 0) {
    return ''
  }
  if (list?.length === 1) {
    return list[0].color
  }
  const color = list.map((item: any) => `${item.color} ${item.step}%`).join(',')
  return `linear-gradient(${angle}deg,${color})`
}

/**
 * 获取时间差
 */
export function getTimeDifference(start: any, end?: any) {
  const startDayjs = dayjs(start)
  const endDayjs = dayjs(end)

  // const diffInMilliseconds = endDayjs.diff(startDayjs)
  const diffInMinutes = endDayjs.diff(startDayjs, 'minute')
  const diffInHours = endDayjs.diff(startDayjs, 'hour')
  const diffInDays = endDayjs.diff(startDayjs, 'day')

  if (diffInDays > 0) {
    return `${diffInDays}天`
  } else if (diffInHours > 0) {
    return `${diffInHours}小时`
  }
  return `${diffInMinutes}分钟`
}

/**
 * 密码校验：字母支持大小写
 * 必须包含数字、字母和特殊字符
 * 长度支持8到15位
 */
export function validPassword(str: string) {
  const reg = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_]).{8,15}$/
  return reg.test(str)
}

/**
 * 唯一id生成器
 */
export function genNanoid(size?: number) {
  return nanoid(size)
}

/**
 * 根据表达式计算值
 */
function evaluateExpression(value1: any, value2: any, operator: string) {
  const operators: { [key: string]: any } = {
    '==': (a: any, b: any) => a == b,
    '!=': (a: any, b: any) => a != b,
    '>': (a: any, b: any) => a > b,
    '<': (a: any, b: any) => a < b
  }
  if (operators[operator]) {
    return operators[operator](value1, value2)
  }
  throw new Error('不支持的操作符: ' + operator)
}
/**
 * 根据受控类型，判断对应的返回是否为真
 */
export function judgeEnslavementFn(arr: any[], data: any) {
  const obj: any = {
    hide: false,
    disable: false
  }
  if (!arr.length) {
    return obj
  }
  for (let ix = 0, len = arr?.length; ix < len; ix++) {
    const { type, condition } = arr[ix]
    const flag =
      condition.length &&
      condition.some((item: any) => evaluateExpression(data[item.key], item.value, item.operator))
    obj[type] = flag
  }
  return obj
}

/**
 * 返回组件中的子组件，兼容容器，面板等组件
 */
export function getCompChildren(child: Widget): any {
  if (child.children && Array.isArray(child.children) && child.children.length > 0) {
    return child.children
  }
  const defaultData = child.dataProp?.defaultData
  if (
    Array.isArray(defaultData) &&
    defaultData.every((item: any) => item.list !== undefined) &&
    defaultData.some((item: any) => item.list.length > 0)
  ) {
    return defaultData
  }
  return []
}

export function hasChildrenFn(el: Widget) {
  return el.children && Array.isArray(el.children) && el.children.length > 0
}
export function hasListComsFn(el: Widget) {
  const defaultData = el.dataProp?.defaultData
  if (
    Array.isArray(defaultData) &&
    defaultData.every((item: any) => item.list !== undefined) &&
    defaultData.some((item: any) => item.list.length > 0)
  ) {
    return true
  }
  return false
}

export function hex2Rgba(hex: string, alpha: number) {
  hex = hex.replace(/^#/, '')
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map(function (hexChar) {
        return hexChar + hexChar
      })
      .join('')
  }
  // 解析红、绿、蓝通道的值
  const r = parseInt(hex.slice(0, 2), 16)
  const g = parseInt(hex.slice(2, 4), 16)
  const b = parseInt(hex.slice(4, 6), 16)
  // 返回RGBA格式的颜色值
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

/**
 * 替代eval函数
 */
export function evalFn(obj: any) {
  return Function('"use strict";return (' + obj + ')')()
}

const panelType = ['HHTabPaneWidget', 'BigScreenPanel', 'HHStep', 'FormStep']
/**
 * 根据key值返回其panel种的父节点
 */
export function findParentNode(trees: Widget[], key: number | string): Widget | undefined {
  function traverseAndFindParent(
    nodes: Widget[],
    key: number | string,
    parent?: Widget
  ): Widget | undefined {
    for (const node of nodes) {
      if (node.key === key) {
        return parent
      }
      const children = getCompChildren(node)
      if (children.length > 0) {
        const parentNode = findInList(children, key, node)
        if (parentNode) {
          return parentNode
        }
      }
    }
    return undefined
  }
  function findInList(
    listData: { list: Widget[] }[],
    key: number | string,
    parent: Widget
  ): Widget | undefined {
    for (const item of listData) {
      const result = traverseAndFindParent(item.list, key, parent)
      if (result) {
        return result
      }
    }
    return undefined
  }
  const panelTrees = trees.filter((item) => panelType.includes(item.type))
  return traverseAndFindParent(panelTrees, key)
}
/**
 * 查找面板的子组件
 */
export function findPanelChildren(panel: Widget, key: number | string): any {
  function traverseFind(nodes: Widget[], key: any): boolean {
    for (let i = nodes.length - 1; i >= 0; i--) {
      const node = nodes[i]
      // console.log('node.key', node.key)
      if (node.key === key) {
        return true
      }
      const children = getCompChildren(node)
      if (children.length) {
        for (const childObj of children) {
          const isEnd = traverseFind(childObj.list, key)
          if (isEnd) {
            return true
          }
        }
      }
    }
    return false
  }
  const children = panel?.dataProp?.defaultData
  for (let ix = 0, len = children?.length; ix < len; ix++) {
    const item = children[ix]
    const isEnd = traverseFind(item.list, key)
    if (isEnd) {
      return { item, ix }
    }
  }
  return {
    item: null,
    ix: -1
  }
}

/**
 * 根据key值删除数组中的元素
 */
export function rmByKey(array: any[], keyVal: any, keyProp?: string) {
  if (keyProp) {
    const ix = array.findIndex((item) => item[keyProp] === keyVal)
    if (ix !== -1) {
      array.splice(ix, 1)
    }
    return array
  }
  const ix = array.findIndex((item) => item === keyVal)
  if (ix !== -1) {
    array.splice(ix, 1)
  }
  return array
}

/**
 * 本地存储
 * 记录用户操作
 */
export class RECORD {
  // record: { [key: string]: string } = {}
  private localKey: string
  constructor(key: string) {
    this.localKey = key
    this._init()
  }
  /**
   * 初始化存储对象
   */
  _init() {
    const record = localStorage.getItem(this.localKey)
    if (!record) {
      localStorage.setItem(this.localKey, JSON.stringify({}))
    }
  }
  /**
   * 获取存储对象
   */
  _getStorage() {
    return JSON.parse(localStorage.getItem(this.localKey) || '{}')
  }
  /**
   * 设置存储对象
   */
  _setStorage(obj: any) {
    localStorage.setItem(this.localKey, JSON.stringify(obj))
  }
  /**
   * 设置记录
   */
  set(key: string, value: any) {
    const record = this._getStorage()
    record[key] = value
    this._setStorage(record)
  }
  /**
   * 获取记录
   */
  get(key: string, dv?: any) {
    const record = this._getStorage()
    return record[key] || dv
  }
  /**
   * 删除记录，恢复默认行为
   */
  remove(key: string) {
    const record = this._getStorage()
    if (key in record) {
      delete record[key]
      this._setStorage(record)
    }
  }
  clear() {
    this._setStorage({})
  }
  has(key: string) {
    const storageObject = this._getStorage()
    return key in storageObject
  }
  getAll() {
    return this._getStorage()
  }
  clearAll() {
    localStorage.clear()
  }
}

/**
 * 清除记录
 */
export function recordClearAll() {
  const keys = ['custom_query', 'table-log']
  for (const item of keys) {
    localStorage.removeItem(item)
  }
}

/**
 * 格式化浮点数
 * 非数字原样返回
 */
export const fomatFloatV2 = (num: any, n = 1) => {
  if (isNaN(parseFloat(`${num}`))) {
    return num
  }
  return Math.round(num * Math.pow(10, n)) / Math.pow(10, n)
}

export const signMapping: any = {
  gt: {
    txt: '大于',
    html: '&gt;',
    sign: '[',
    show: '>',
    switch: '<',
    fn: (n: any, v: any) => +n > +v
  },
  ge: {
    txt: '大于等于',
    html: '&ge;',
    sign: '{',
    show: '≥',
    switch: '≤',
    fn: (n: any, v: any) => +n >= +v
  },
  lt: {
    txt: '小于',
    html: '&lt;',
    sign: ']',
    show: '<',
    fn: (n: any, v: any) => +n < +v
  },
  le: {
    txt: '小于等于',
    html: '&le;',
    sign: '}',
    show: '≤',
    fn: (n: any, v: any) => +n <= +v
  }
}

/**
 * 将树结构转换成扁平数组
 */
export function tree2ArrayFn(tree: any[]) {
  const stack = [...tree]
  const result = []
  while (stack.length) {
    const node = stack.pop()
    const { children, ...rest } = node
    result.push(rest)
    if (children && children.length) {
      stack.push(...children.slice().reverse())
    }
  }
  return result
}
/**
 * 将扁平数组转换成树结构
 */
export function arrayToTreeOptimized(items: any[], parentId = 0) {
  const itemMap: any = {}
  const tree: any[] = []
  items.forEach((item) => {
    itemMap[item.id] = { ...item, children: [] }
  })
  items.forEach((item) => {
    if (item.parentId === parentId) {
      tree.push(itemMap[item.id])
    } else {
      if (itemMap[item.parentId]) {
        itemMap[item.parentId].children.push(itemMap[item.id])
      }
    }
  })
  return tree
}

export function arr2obj(arr: any[], key = 'key', value = 'value') {
  const obj: any = {}
  arr.forEach((item) => {
    const k = item[key]
    obj[k] = item[value]
  })
  return obj
}

export function buildPermissionTree(flatArray: any[]) {
  // 创建一个映射，方便通过 id 快速查找节点
  const nodeMap: any = {}
  flatArray.forEach((node) => {
    nodeMap[node.id] = node
  })
  // 为每个节点构建 permission
  flatArray.forEach((node) => {
    const permissionPath = []
    let current = node
    // 递归查找父节点，直到根节点（parentId 为 0）
    while (current && current.parentId !== 0) {
      permissionPath.unshift(current.name) // 将当前节点名称添加到路径开头
      current = nodeMap[current.parentId] // 移动到父节点
    }
    // 如果当前节点存在且不是根节点（即 parentId 为 0 的节点），则添加到路径
    if (current && current.parentId === 0) {
      permissionPath.unshift(current.name)
    }
    // 将 permission 路径用冒号连接，并存储到节点的 permission 字段
    node.permission_path = permissionPath.join(':')
  })
  return flatArray
}

/**
 * 图片地址生成器
 */
export function genImgUrl(project: any, type: 'LOGO' | 'LOGIN' | 'COVER', path = 'projects') {
  return `/api/v1/${path}/${project.id}/resource/download/${type}?t=${project.lastModDate}`
}

/**
 * 模板图片地址生成器
 */
export function getTemplateImgUrl(id: number, type: 'LOGO' | 'COVER') {
  return `/api/v1/template/${id}/resource/download/${type}`
}

/**
 * 将任意格式的颜色（HEX/RGB/RGBA/HSL/HSLA）与新的透明度结合，返回RGBA格式
 * @param {string} color - 输入颜色（支持 HEX、RGB、RGBA、HSL、HSLA）
 * @param {number} newOpacity - 新的透明度（0-1）
 * @returns {string} 返回 rgba(r, g, b, a) 格式
 */
export function applyOpacity(color: any, newOpacity: number) {
  // 检查 newOpacity 是否合法
  if (typeof newOpacity !== 'number' || newOpacity < 0 || newOpacity > 1) {
    throw new Error('Opacity must be a number between 0 and 1')
  }

  // 解析颜色，获取 r, g, b, a
  let { r, g, b, a } = parseColor(color)

  // 计算最终透明度（当前透明度 * 新的透明度）
  const finalAlpha = a * newOpacity

  // 返回 rgba 字符串
  return `rgba(${r}, ${g}, ${b}, ${finalAlpha})`
}

/**
 * 解析颜色字符串，返回 { r, g, b, a } 对象
 * @param {string} colorStr - 颜色字符串
 * @returns {{ r: number, g: number, b: number, a: number }}
 */
function parseColor(colorStr: string) {
  colorStr = colorStr.trim().toLowerCase()

  // HEX 颜色（#RGB, #RGBA, #RRGGBB, #RRGGBBAA）
  if (colorStr.startsWith('#')) {
    return parseHexColor(colorStr)
  }
  // RGB/RGBA 颜色（rgb(255,0,0) 或 rgba(255,0,0,0.5)）
  else if (colorStr.startsWith('rgb')) {
    return parseRgbColor(colorStr)
  }
  // HSL/HSLA 颜色（hsl(120,100%,50%) 或 hsla(120,100%,50%,0.5)）
  else if (colorStr.startsWith('hsl')) {
    return parseHslColor(colorStr)
  }
  // 其他情况报错
  else {
    throw new Error('Unsupported color format')
  }
}

/**
 * 解析 HEX 颜色（#RGB, #RGBA, #RRGGBB, #RRGGBBAA）
 * @param {string} hex - HEX 颜色字符串
 * @returns {{ r: number, g: number, b: number, a: number }}
 */
function parseHexColor(hex) {
  hex = hex.replace('#', '')

  // 处理缩写格式（#RGB → #RRGGBB, #RGBA → #RRGGBBAA）
  if (hex.length === 3 || hex.length === 4) {
    hex = hex
      .split('')
      .map((c) => c + c)
      .join('')
  }

  // 解析 HEX 值
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)
  let a = 1

  // 如果有 Alpha 通道（8位 HEX）
  if (hex.length === 8) {
    const alphaHex = hex.substring(6, 8)
    a = parseInt(alphaHex, 16) / 255 // 转换为 0-1 范围
  }

  return { r, g, b, a }
}

/**
 * 解析 RGB/RGBA 颜色
 * @param {string} rgbStr - RGB/RGBA 字符串
 * @returns {{ r: number, g: number, b: number, a: number }}
 */
function parseRgbColor(rgbStr) {
  // 提取括号内的内容（如 "255, 0, 0, 0.5"）
  const match = rgbStr.match(/rgba?\(([^)]+)\)/i)
  if (!match) throw new Error('Invalid RGB/RGBA format')

  const parts = match[1].split(',').map((s) => parseFloat(s.trim()))

  // 检查是否合法
  if (parts.length !== 3 && parts.length !== 4) {
    throw new Error('RGB/RGBA must have 3 or 4 components')
  }

  const [r, g, b] = parts
  const a = parts.length === 4 ? parts[3] : 1

  return { r, g, b, a }
}

/**
 * 解析 HSL/HSLA 颜色，并转换为 RGB
 * @param {string} hslStr - HSL/HSLA 字符串
 * @returns {{ r: number, g: number, b: number, a: number }}
 */
function parseHslColor(hslStr) {
  // 提取括号内的内容（如 "120, 100%, 50%, 0.5"）
  const match = hslStr.match(/hsla?\(([^)]+)\)/i)
  if (!match) throw new Error('Invalid HSL/HSLA format')

  const parts = match[1].split(',').map((s) => {
    const trimmed = s.trim()
    // 处理百分比（如 "50%" → 0.5）
    if (trimmed.endsWith('%')) {
      return parseFloat(trimmed) / 100
    }
    return parseFloat(trimmed)
  })

  // 检查是否合法
  if (parts.length !== 3 && parts.length !== 4) {
    throw new Error('HSL/HSLA must have 3 or 4 components')
  }

  let [h, s, l] = parts
  const a = parts.length === 4 ? parts[3] : 1

  // 将 HSL 转换为 RGB
  const { r, g, b } = hslToRgb(h, s, l)

  return { r, g, b, a }
}

/**
 * 将 HSL 转换为 RGB
 * @param {number} h - 色相（0-360）
 * @param {number} s - 饱和度（0-1）
 * @param {number} l - 亮度（0-1）
 * @returns {{ r: number, g: number, b: number }}
 */
function hslToRgb(h: number, s: number, l: number) {
  h /= 360
  let r, g, b

  if (s === 0) {
    r = g = b = l // 灰色
  } else {
    const hue2rgb = (p, q, t) => {
      if (t < 0) t += 1
      if (t > 1) t -= 1
      if (t < 1 / 6) return p + (q - p) * 6 * t
      if (t < 1 / 2) return q
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6
      return p
    }

    const q = l < 0.5 ? l * (1 + s) : l + s - l * s
    const p = 2 * l - q

    r = hue2rgb(p, q, h + 1 / 3)
    g = hue2rgb(p, q, h)
    b = hue2rgb(p, q, h - 1 / 3)
  }

  return {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b * 255)
  }
}
/**
 * 根据 select 数组，禁用 source 中不在 select 中的节点。
 * @param source 原始 options（多级树）
 * @param select 一维数组，包含允许选择的 value
 * @returns 处理后的 options
 */
export function filterAndDisableOptions(source: any[], select: any[], valueField = 'value') {
  const cloned = cloneDeep(source)
  const mark = (nodes: any[]) => {
    return nodes.map((node) => {
      const newNode = { ...node }
      // 设置禁用标记
      if (!select.includes(newNode[valueField])) {
        newNode.disabled = true
      }
      // 如果有 children，递归处理
      if (newNode.children) {
        newNode.children = mark(newNode.children)
      }
      return newNode
    })
  }

  return mark(cloned)
}

/**
 * 还原所有节点的 disabled 状态（设为 false 或删除该字段）
 * @param source 已被标记过 disabled 的 options
 * @returns 重置后的新 options
 */
export function restoreAllDisabledNodes(source: any[]) {
  const cloned = cloneDeep(source)
  const clearDisabled = (nodes: any[]) => {
    return nodes.map((node) => {
      const newNode = { ...node }
      // 移除或设置 disabled: false
      if ('disabled' in newNode) {
        delete newNode.disabled
      }
      // 递归处理子节点
      if (newNode.children) {
        newNode.children = clearDisabled(newNode.children)
      }
      return newNode
    })
  }
  return clearDisabled(cloned)
}

export function emitAsync(eventName: string, payload?: any) {
  return new Promise((resolve) => {
    emitter.emit(eventName, {
      ...payload,
      callback: resolve
    })
  })
}

export function emitAsyncAll(eventName: string, payload?: any) {
  const listeners: any = emitter.all.get(eventName)
  console.log(listeners)

  if (!listeners) {
    return Promise.resolve([])
  }
  const promises = []
  for (const handler of listeners) {
    try {
      const result = handler(payload)
      if (result instanceof Promise) {
        promises.push(result)
      } else {
        promises.push(Promise.resolve(result))
      }
    } catch (err) {
      promises.push(Promise.reject(err))
    }
  }
  return Promise.all(promises)
}

export function emitWithCallbacks(eventName: string, payload: any) {
  const listeners = emitter.all.get(eventName)
  if (!listeners) {
    return Promise.resolve([])
  }

  const callbackPromises = []

  for (const handler of listeners) {
    callbackPromises.push(
      new Promise((resolve, reject) => {
        try {
          handler(payload, resolve)
        } catch (err) {
          reject(err)
        }
      })
    )
  }

  return Promise.all(callbackPromises)
}

/**
 * 等待函数
 * @param {number} ms 等待时间（毫秒）
 * @returns {Promise} 在指定时间后解析的 Promise
 */
export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/**
 * 规范化成 6 位十六进制颜色
 */
export function toHex6(input: string, opts: any = {}) {
  const { withHash = true, lowercase = true } = opts
  if (typeof input !== 'string') {
    return null
  }
  let s = input.trim()
  if (s.startsWith('#')) {
    s = s.slice(1)
  }
  if (!/^[0-9a-fA-F]{3}$|^[0-9a-fA-F]{6}$/.test(s)) {
    return null
  }
  // 3 位扩展为 6 位
  if (s.length === 3) {
    s = s
      .split('')
      .map((ch) => ch + ch)
      .join('')
  }
  s = lowercase ? s.toLowerCase() : s.toUpperCase()
  return withHash ? `#${s}` : s
}

function stableStringify(obj: any): string {
  if (isPlainObject(obj)) {
    // 普通对象：对 key 排序后再递归序列化
    return `{${Object.keys(obj)
      .sort()
      .map((k) => `${k}:${stableStringify(obj[k])}`)
      .join(',')}}`
  }
  if (Array.isArray(obj)) {
    // 数组：逐个递归
    return `[${obj.map(stableStringify).join(',')}]`
  }
  return String(obj) // 基本类型
}

export function isSubset(A: any[], B: any[]): boolean {
  if (!Array.isArray(A) || !Array.isArray(B)) {
    return false
  }
  const setB = new Set(B.map(stableStringify))
  return A.every((a) => setB.has(stableStringify(a)))
}

/**
 * 在树中查找节点
 * @param {Array} tree - 树数据，数组形式
 * @param {string} key - 要匹配的属性名
 * @param {any} value - 要匹配的属性值
 * @param {string} [childrenKey='children'] - 子节点字段名，默认 'children'
 * @returns {Object|undefined} - 找到则返回节点对象，否则返回 undefined
 */
export function findNodeByKey(
  tree: any[],
  value: any,
  key: any = 'id',
  childrenKey = 'children'
): any {
  for (const node of tree) {
    if (node[key] === value) {
      return node
    }
    if (node[childrenKey] && node[childrenKey].length > 0) {
      const found = findNodeByKey(node[childrenKey], value, key, childrenKey)
      if (found) {
        return found
      }
    }
  }
  return undefined
}

/**
 * 返回数结构中符合条件的节点数组
 */
export function findNodesByProp(arr: any[], prop: any, value: any, childrenKey = 'children') {
  const result: any[] = []
  function traverse(nodes: any[]) {
    if (!Array.isArray(nodes)) {
      return
    }
    for (const item of nodes) {
      if (item[prop] === value) {
        result.push(item)
      }
      if (Array.isArray(item[childrenKey])) {
        traverse(item[childrenKey])
      }
    }
  }
  traverse(arr)
  return result
}

/**
 * 替换页面的资源
 */
export function replacePageAssets(pages: any[], assetsOpts: any[] = []) {
  for (const item of pages) {
    const { variables } = item
    const img = variables?.background.img
    if (
      variables?.pageType === 'bigScreen' &&
      variables?.background &&
      variables?.background.enable &&
      img &&
      img.includes('.')
    ) {
      const imgId = assetsOpts?.find((i: any) => i.name === img)?.id
      imgId && (item.variables.background.img = imgId)
    }
  }
}
/**
 * 替换组件中的图片资源
 * @param components 组件列表
 * @param assetsOpts 资源列表
 */
export function replaceComponentAssets(components: any[], assetsOpts: any[]) {
  // console.log('replaceComponentAssets', components, assetsOpts)
  for (const component of components) {
    const { type, prop } = component
    switch (type) {
      case 'HHGrid':
        {
          const img = prop.bgImg
          if (img && img.includes('.')) {
            const imgId = assetsOpts.find((i: any) => i.name === img)?.id
            imgId && (component.prop.bgImg = imgId)
          }
        }
        break
      case 'HHStep':
      case 'FormStep':
        for (const key in prop.iconMapping) {
          if (!Object.hasOwn(prop.iconMapping, key)) {
            continue
          }
          const el = prop.iconMapping[key]
          if (el && el.includes('.')) {
            const imgId = assetsOpts.find((i: any) => i.name === el)?.id
            imgId && (component.prop.iconMapping[key] = imgId)
          }
        }
        break
      case 'HHImgWidge':
      case 'BigScreenHeaderTitle':
      case 'BigScreenImage':
        {
          const img = prop.imgUrl
          if (img && img.includes('.')) {
            const imgId = assetsOpts.find((i: any) => i.name === img)?.id
            imgId && (component.prop.imgUrl = imgId)
          }
        }
        break
      case 'HHAssetsWidge':
        {
          const img = prop.assets
          if (img && img.includes('.')) {
            const imgId = assetsOpts.find((i: any) => i.name === img)?.id
            imgId && (component.prop.assets = imgId)
          }
        }
        break
      case 'HHProcess':
        {
          const img = prop.img
          if (img && img.includes('.')) {
            const imgId = assetsOpts.find((i: any) => i.name === img)?.id
            imgId && (component.prop.img = imgId)
          }
        }
        break
      case 'BigScreenFlop':
        {
          const img = prop.icon
          if (img && img.includes('.')) {
            const imgId = assetsOpts.find((i: any) => i.name === img)?.id
            imgId && (component.prop.icon = imgId)
          }
        }
        break
      default:
        break
    }
  }
}

export async function testPrint() {
  try {
    const res = await axios.get(
      'http://10.10.4.49:30304/api/v1/projects/1014232707770748929/storage/download/1-1014232707770748929.png',
      {
        responseType: 'blob',
        headers: {
          Accept: 'image/png,image/jpeg,application/pdf,*/*',
          authorization:
            'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJIQU9IQU5fWkVSTyIsInN1YiI6ImxpbiIsImp0aSI6Ijg5MzQ3OTkyNjc1NjQxMzQ0MCIsInR5cGUiOiJVU0VSIiwicGlkIjowLCJleHAiOjE3NTkxMjQ4Nzd9.vDtPXThQt5FGFCYr1LthNEWHsNbSXR7LoDu5mO8XWY0',
          timestamp: 1758535158196,
          sign: '4a08dc801a57e02a3be0b3bdec38471f'
        }
      }
    )

    console.log('content-type:', res.headers['content-type'])
    printFile(res.data, res.headers['content-type'])
  } catch (err) {
    console.error('下载失败:', err)
  }
}

/**
 * 打印文件（仅支持图片和 PDF）
 * @param {Blob} data - 响应数据（Blob）
 * @param {string} contentType - 响应头 Content-Type
 */
export function printFile(data: any, contentType: string) {
  let fileUrl = ''
  let fileType = ''
  const blobUrl = URL.createObjectURL(new Blob([data], { type: contentType }))

  if (contentType.startsWith('image/')) {
    fileType = 'img'
  } else if (contentType === 'application/pdf') {
    fileType = 'pdf'
  } else {
    ElMessage.warning('暂不支持该文件类型打印，仅支持图片和 PDF')
    return
  }

  const printWindow = window.open('', '_blank')
  if (fileType === 'img') {
    printWindow!.document.write(`
          <html>
            <head><title>打印图片</title></head>
            <body style="margin:0;display:flex;align-items:center;justify-content:center;">
              <img src="${blobUrl}" style="max-width:100%;max-height:100%;" onload="window.print();"/>
            </body>
          </html>
        `)
  } else if (fileType === 'pdf') {
    printWindow!.document.write(`
      <html>
        <head><title>打印 PDF</title></head>
        <body style="margin:0">
          <iframe src="${fileUrl}" width="100%" height="100%" style="border:none;"></iframe>
          <script>
            window.onload = () => {
              const iframe = document.querySelector('iframe')
              iframe.contentWindow.focus()
              iframe.contentWindow.print()
            }
          </script>
        </body>
      </html>
    `)
  }
  printWindow!.document.close()
}
